// This file is automatically generated. Do not edit manually.

import { CustomFunctionUiActionContext } from "src/api/generated/erp/customFunctions/triggers/uiAction/context/customFunctionUiActionContext";
import { SubmittedCustomFunctionInputFileField } from "src/api/generated/erp/customFunctions/model/submittedCustomFunctionInputFileField";
import { CustomFunctionUiActionExecutionResult } from "src/api/generated/erp/customFunctions/triggers/uiAction/customFunctionUiActionExecutionResult";
import { CustomFunctionUiActionContextType } from "src/api/generated/io/aavo/applications/db/erp/types/customFunctionUiActionContextType";
import { CustomFunctionFileInput } from "src/api/generated/erp/customFunctions/model/customFunctionFileInput";
import { CustomFunctionUiActionObjectCardinality } from "src/api/generated/erp/db/types/enums/customFunctionUiActionObjectCardinality";
import { CustomFunctionUiActionResultHandling } from "src/api/generated/erp/db/types/enums/customFunctionUiActionResultHandling";
import { CustomFunctionUserInputPresentation } from "src/api/generated/erp/customFunctions/model/customFunctionUserInputPresentation";
import { CustomFunctionUiActionView } from "src/api/generated/io/aavo/applications/db/erp/types/customFunctionUiActionView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomFunctionUiActionApi {
	export async function getUiActions(): Promise<Array<CustomFunctionUiActionApi_UiActionDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customFunctions/uiActions/getUiActions",
			method: "POST",
			data: {},
		});
		return response as Array<CustomFunctionUiActionApi_UiActionDto>;
	}

	export async function executeUiAction(args: {
		triggerLineageId: string;
		context: CustomFunctionUiActionContext;
		userInput?: unknown | null | undefined;
		fileInputs?: Array<SubmittedCustomFunctionInputFileField>;
		idempotencyKey?: string;
	}): Promise<CustomFunctionUiActionExecutionResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customFunctions/uiActions/executeUiAction",
			method: "POST",
			data: {
				triggerLineageId: args.triggerLineageId,
				context: args.context,
				userInput: args.userInput,
				fileInputs: args.fileInputs,
				idempotencyKey: args.idempotencyKey,
			},
		});
		return response as CustomFunctionUiActionExecutionResult;
	}

	export async function resumeUiAction(args: {
		userInputRequestId: number;
		response: unknown;
		idempotencyKey: string;
	}): Promise<CustomFunctionUiActionExecutionResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customFunctions/uiActions/resumeUiAction",
			method: "POST",
			data: {
				userInputRequestId: args.userInputRequestId,
				response: args.response,
				idempotencyKey: args.idempotencyKey,
			},
		});
		return response as CustomFunctionUiActionExecutionResult;
	}

	export async function cancelUiActionInputRequest(args: { userInputRequestId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/customFunctions/uiActions/cancelUiActionInputRequest",
			method: "POST",
			data: {
				userInputRequestId: args.userInputRequestId,
			},
		});
		return response as void;
	}
}

export interface CustomFunctionUiActionApi_UiActionDto {
	contextType: CustomFunctionUiActionContextType;
	fileInputs: Array<CustomFunctionFileInput>;
	iconName: string;
	label: string;
	objectCardinality: CustomFunctionUiActionObjectCardinality;
	resultHandlings: Array<CustomFunctionUiActionResultHandling>;
	triggerLineageId: string;
	userInputPresentations: Record<string, CustomFunctionUserInputPresentation>;
	userInputSchema: unknown | null | undefined;
	views: Array<CustomFunctionUiActionView>;
}
